import React from "react";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import { withStyles } from "material-ui/styles";

import styles from "../styles";

class Toolbar extends React.Component {
  toggle() {
    this.setState({
      search: !this.state.search
    });
  }

  render() {
    const {
      classes,
      translate,
      toggle,
      add,
      showMove,
      showEdit,
      move,
      showDelete,
      del,
      edit,
      showRecert,
      recert,
      showReportGen,
      reportGen,
      toggleFilters,
      createEnabled,
      refresh,
      job
    } = this.props;

    let disableControlButtons = false;
    if (job && job.pendingcount) {
      disableControlButtons = true;
    }

    return (
      <div>
        <Tooltip
          title={translate("tooltip_reload_tests")}
          disableTriggerFocus={true}
        >
          <Button
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => refresh()}
          >
            <Icon>refresh</Icon>
          </Button>
        </Tooltip>
        {createEnabled && (
          <Tooltip
            title={translate("tooltip_create_tests")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Create Tests"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => add()}
              disabled={disableControlButtons}
            >
              <Icon>add</Icon>
            </Button>
          </Tooltip>
        )}
        {showEdit && (
          <Tooltip title={translate("tooltip_edit")} disableTriggerFocus={true}>
            <Button
              aria-label="Edit"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => edit()}
              disabled={disableControlButtons}
            >
              <Icon>edit</Icon>
            </Button>
          </Tooltip>
        )}
        {showRecert && (
          <Tooltip
            title={translate("tooltip_recertify")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Recertify"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => recert()}
              disabled={disableControlButtons}
            >
              <Icon>repeat</Icon>
            </Button>
          </Tooltip>
        )}
        {showMove && (
          <Tooltip
            title={translate("tooltip_move_tests")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Move Tests"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => move()}
              disabled={disableControlButtons}
            >
              <Icon>folder</Icon>
            </Button>
          </Tooltip>
        )}
        {showDelete && (
          <Tooltip
            title={translate("tooltip_delete")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Delete"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => del()}
              disabled={disableControlButtons}
            >
              <Icon>delete</Icon>
            </Button>
          </Tooltip>
        )}
        {showReportGen && (
          <Tooltip
            title={translate("tooltip_create_report")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Create Report"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => reportGen()}
              disabled={disableControlButtons}
            >
              <Icon>insert_drive_file</Icon>
            </Button>
          </Tooltip>
        )}
        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button
            aria-label="Filter"
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => toggleFilters()}
          >
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>
        <Tooltip
          title={translate("tooltip_view_columns")}
          disableTriggerFocus={true}
        >
          <Button
            aria-label="View Columns"
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => toggle()}
          >
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div>
    );
  }
}

export default withStyles(styles)(Toolbar);



// WEBPACK FOOTER //
// ./src/components/job/toolbar/index.js